import axios from 'axios';
import { EXPORT_FILE, GET_EXPORT_FILE } from './constants';

function reject(error) {
  if (!error.response) {
    return Promise.reject(error);
  }

  const { data } = error.response;

  return Promise.reject(new Error(data.errors[0].user_message));
}

export function exportFile(payload, headers) {
  return axios.post(EXPORT_FILE, payload, { headers }).catch(reject);
}

export function getExportFile(exportId) {
  return axios.get(GET_EXPORT_FILE(exportId)).catch(reject);
}
